// extracted by mini-css-extract-plugin
export default {"root":"OicTZW","isDisabled":"oTAaIl","priority-primary":"PAqiHS","priorityPrimary":"PAqiHS","priority-secondary":"jyi1Fc","prioritySecondary":"jyi1Fc"};